import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sorry-dialog',
  templateUrl: './sorry-dialog.component.html',
  styleUrls: ['./sorry-dialog.component.scss'],
})
export class SorryDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string },
    public dialogRef: MatDialogRef<SorryDialogComponent>,
  ) {}
}
